import { io } from 'socket.io-client'
import emitter from './event'
import { MessageBox } from 'element-ui';
import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'production' ? 'https://chat.laway.cn/api/' : `https://chat.laway.cn/api/`

const fetchInstance = axios.create({
  baseURL: baseURL,
  timeout: 60 * 1000
})

const sleep = (n) =>
  new Promise((r) => {
    setTimeout(r, n)
  })

const deviceWebRTCLogin = async (code, state) => {
  const { data } = await fetchInstance.post('/account/loginByDevice', {
    platform: 'android',
    type: 'device',
    identification: 'zhuomian',
    appUUID: '14ee8a3c-e391-4ace-bcae-e32f8f6364ca',
    code,
    state
  })

  if (data.code === 1) {
    return data.result
  }

  return null
}

let socketInstance = null

export const socketInitialization = async () => {
  const code = window.localStorage.getItem('code') || ''
  if (!code) {
    // console.log('当前系统尚未注册')
    await sleep(2000)
    return await socketInitialization()
  }

  const deviceInfo = await deviceWebRTCLogin(code)

  if (!deviceInfo) {
    MessageBox.alert({
      type: 'warning',
      title: '警告',
      message: '当前系统异常，请联系管理员'
    })
  }

  try {
    // 开发 127.0.0.1:8888
    // 生产 chat.laway.cn
    // socketInstance = await io('http://127.0.0.1:8888/', {
    console.log(process.env.NODE_ENV)
    const query = {
      version: '1',
      role: 'consumer'
    }
    if (deviceInfo && deviceInfo.token) {
      query.token = 'Bearer ' + deviceInfo.token
    }

    socketInstance = await io(process.env.NODE_ENV === 'production' ? 'https://chat.laway.cn' : `https://chat.laway.cn`, {
      query,
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      timeout: 10000
    })

    socketInstance.signalUpdate = null

    socketInstance.on('signal', (data) => {
      if (socketInstance.signalUpdate) socketInstance.signalUpdate(data)
    })

    socketInstance.on('joinRoom', (data) => {
      window.roomName = data
    })

    socketInstance.on('receiveMsg', (data) => {
      if (data.type === 'rtc') {
        // if (router.currentRoute.fullPath !== '/video') {
        //   router.push({ path: '/video', query: { status: 'received', connectType: data.attribute.connectType } })
        // } else {
        //   router.currentRoute.query = { status: 'received', connectType: data.attribute.connectType }
        // }
        // router.push({ path: '/video', query: { status: 'received', connectType: data.attribute.connectType } })
        emitter.emit('rtc', data)
      }
    })

    socketInstance.sendSignal = (data) => {
      socketInstance.emit('signal', data)
    }

    return socketInstance
  } catch (err) {
    console.error(err)
    return null
  }
}

